// Ultimate World-Class Data - Premium Pricing ₹51 to ₹501

export const ultimateImages = {
  logo: "https://static.prod-images.emergentagent.com/jobs/332ee6e8-0482-4872-ad2f-d25a2f1870ee/images/d79da8b6085ae1f03c533764f408b16d555cf9d419b75e8672ae63e0adce7e6f.png",
  heroBg: "https://static.prod-images.emergentagent.com/jobs/332ee6e8-0482-4872-ad2f-d25a2f1870ee/images/7e0e7d8fc08a49c9d45efacc1852e57870a96e433573598b06426a064c85bc65.png",
  aghoriRitual: "https://static.prod-images.emergentagent.com/jobs/332ee6e8-0482-4872-ad2f-d25a2f1870ee/images/98cfa06298cbb69cfacc296789dce19f1933ec73ebcf5eb0ecf17cecb9cd81cd.png",
  sacredYantra: "https://static.prod-images.emergentagent.com/jobs/332ee6e8-0482-4872-ad2f-d25a2f1870ee/images/7e69b741bb0d52d4129ebce2a43cd6031b90bf76c1303fef9c4e396316023ac4.png",
  // Real photos of Mata Maliha
  mataGhat: "https://customer-assets.emergentagent.com/job_332ee6e8-0482-4872-ad2f-d25a2f1870ee/artifacts/n7zr3y8o_WhatsApp%20Image%202026-02-13%20at%203.08.07%20PM.jpeg",
  mataSummit: "https://customer-assets.emergentagent.com/job_332ee6e8-0482-4872-ad2f-d25a2f1870ee/artifacts/6dw815g6_WhatsApp%20Image%202026-02-13%20at%203.08.08%20PM.jpeg",
  mataFestival1: "https://customer-assets.emergentagent.com/job_332ee6e8-0482-4872-ad2f-d25a2f1870ee/artifacts/925f2jwv_WhatsApp%20Image%202026-02-13%20at%203.08.07%20PM%20%282%29.jpeg",
  mataFestival2: "https://customer-assets.emergentagent.com/job_332ee6e8-0482-4872-ad2f-d25a2f1870ee/artifacts/4i9tg4yx_WhatsApp%20Image%202026-02-13%20at%203.08.07%20PM%20%281%29.jpeg",
  mataMumbai: "https://customer-assets.emergentagent.com/job_332ee6e8-0482-4872-ad2f-d25a2f1870ee/artifacts/eo3m3uc8_WhatsApp%20Image%202026-02-13%20at%203.08.08%20PM%20%281%29.jpeg",
  // New batch - Professional photos of Mata Maliha
  mataHeroGhat: "/img/729af828.webp",
  mataPortrait: "https://customer-assets.emergentagent.com/job_92e27574-6e55-4cb9-9f11-8bc9cf05ca2f/artifacts/42nedpep_WhatsApp%20Image%202026-02-13%20at%203.08.04%20PM.jpeg",
  mataBlessing: "https://customer-assets.emergentagent.com/job_92e27574-6e55-4cb9-9f11-8bc9cf05ca2f/artifacts/i8v49c94_WhatsApp%20Image%202026-02-13%20at%203.08.03%20PM.jpeg",
  mataFireRitual: "https://customer-assets.emergentagent.com/job_92e27574-6e55-4cb9-9f11-8bc9cf05ca2f/artifacts/k97wufcy_WhatsApp%20Image%202026-02-13%20at%203.08.01%20PM.jpeg",
  mataTrishul: "https://customer-assets.emergentagent.com/job_92e27574-6e55-4cb9-9f11-8bc9cf05ca2f/artifacts/urudwrh2_WhatsApp%20Image%202026-02-13%20at%203.08.00%20PM%20%281%29.jpeg",
  mataMeditation: "https://customer-assets.emergentagent.com/job_92e27574-6e55-4cb9-9f11-8bc9cf05ca2f/artifacts/31z0cgdl_WhatsApp%20Image%202026-02-13%20at%203.08.00%20PM.jpeg",
  mataRoobaru: "https://customer-assets.emergentagent.com/job_92e27574-6e55-4cb9-9f11-8bc9cf05ca2f/artifacts/ib11msfn_unnamed.jpg",
  // Sadhana-specific ritual images (no faces)
  sadhnaMasan: "/img/0832e522.webp",
  sadhnaVashikaran: "/img/ae943941.webp",
  sadhnaDhan: "/img/f57fe2fc.webp",
  sadhnaSantan: "/img/31180bfa.webp",
  sadhnaBagalamukhi: "/img/5e843227.webp",
  sadhnaMahakali: "/img/ebdc1873.webp",
  // Promotional Banners - Service specific images
  promoGrahDosh: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/5f50hega_1771068362400.png",
  promoLoveBack: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/jjn9bshy_1771068561192.png",
  promoDebtFree: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/znyjo2gk_1771068569576.png",
  promoSautan: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/pv4qhg7d_1771068581586.png",
  promoVisa: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/hs0n5zra_1771068592054.png",
  // Batch 2 - More promotional banners
  promoCourtCase: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/bhrpdyiz_1771068173098.png",
  promoVivah: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/oti1o1hq_1771068182658.png",
  promoSantan: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/wu3nyodx_1771068330720.png",
  promoDepression: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/xx811lhn_1771068339057.png",
  promoFamilyDispute: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/7hmg5ncc_1771068350709.png",
  // Batch 3 - Additional promotional banners
  promoVisaSuccess: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/osvnbq8b_1771067946822.png",
  promoJobBusiness: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/g6yl7r5i_1771067975866.png",
  promoEducation: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/1k4ry81q_1771067989193.png",
  promoAddiction: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/arhkl8oh_1771068153886.png",
  promoProperty: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/98doxfsw_1771068161036.png",
  // Batch 4 - Premium featured banners (for integrated sections)
  featuredHealth: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/vikaebug_1771067869376.png",
  featuredVisaPremium: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/vylgaxqs_1771067895631.png",
  featuredCourtVictory: "https://customer-assets.emergentagent.com/job_aghori-mata/artifacts/ir22y6qa_1771067936121.png"
};

export const ultimateColors = {
  gold: "#D4AF37",
  crimson: "#DC143C",
  deepPurple: "#4B0082",
  bloodRed: "#8B0000",
  emerald: "#006400",
  royalBlue: "#002366",
  saffron: "#FF6F00",
  silver: "#C0C0C0"
};

export const mataMalihaIntro = {
  title: "माता मलिहा",
  mainTagline: "परम अघोर सिद्धि - असंभव को संभव करने वाली शक्ति",
  subtitle: "🔥 आज ही अपनी समस्या का समाधान पाएं 🔥 हिमालय की गुफाओं से लेकर काशी के श्मशान घाटों तक - 25+ वर्षों की कठोर साधना से प्राप्त दिव्य सिद्धियाँ। जहाँ दुनिया हार मान ले, वहाँ से शुरुआत।",
  description: `🔱 क्या आप जानते हैं? 🔱
  
  आपकी समस्या का समाधान सिर्फ एक फोन कॉल दूर है। लेकिन हर दिन की देरी आपकी समस्या को और गहरा बना रही है। आज 50,000+ लोग खुशहाल जीवन जी रहे हैं क्योंकि उन्होंने समय रहते माता मलिहा जी से संपर्क किया।
  
  ⚠️ चेतावनी: यदि आपने अभी तक कोई कदम नहीं उठाया, तो आपकी समस्या और भी जटिल हो जाएगी। कल का इंतजार न करें - कल कभी नहीं आता।
  
  माता मलिहा जी ने मात्र 16 वर्ष की आयु में गृहत्याग कर हिमालय की कठोर गुफाओं में अघोर साधना आरंभ की। केदारनाथ, बद्रीनाथ और गंगोत्री की बर्फीली गुफाओं में 8 वर्षों तक निरंतर तपस्या की - जहाँ तापमान -30°C तक गिर जाता था, जहाँ कोई सामान्य इंसान 1 घंटा भी नहीं रह सकता।
  
  12 वर्षों तक निरंतर तपस्या के बाद उन्होंने काशी के मणिकर्णिका घाट पर मसान सिद्धि प्राप्त की - यह वही सिद्धि है जो लाखों में एक को मिलती है। इस दौरान उन्होंने 108 श्मशान की यात्रा की और प्रत्येक में विशेष साधना सम्पन्न की।
  
  🔱 आज का सच 🔱
  
  आज वे देश-विदेश के लाखों लोगों की समस्याओं का समाधान कर चुकी हैं। अमेरिका, कनाडा, ब्रिटेन, ऑस्ट्रेलिया, दुबई, सिंगापुर, जर्मनी से भी लोग उनसे मार्गदर्शन लेते हैं। हर दिन 100+ नए लोग उनसे जुड़ते हैं।
  
  💎 क्यों चुनें माता मलिहा जी को? 💎
  
  उनकी साधनाएं इतनी शक्तिशाली हैं कि जो कार्य असंभव लगते हैं, वे भी संभव हो जाते हैं। चाहे काला जादू हो, वशीकरण हो, धन समस्या हो, प्रेम समस्या हो, संतान समस्या हो या पारिवारिक कलह - हर समस्या का 100% समाधान उपलब्ध है।
  
  माता जी की विशेषता यह है कि वे पहले आपकी समस्या का मूल कारण पता करती हैं - जड़ से इलाज, सिर्फ लक्षण नहीं। फिर उसी के अनुसार साधना का चयन करती हैं। कोई एक-साइज-फिट-ऑल नहीं - हर व्यक्ति के लिए व्यक्तिगत समाधान।
  
  📚 दुर्लभ ज्ञान का भंडार 📚
  
  उनके पास दुर्लभ तांत्रिक ग्रंथों का संग्रह है जो 99% तांत्रिकों के पास नहीं होते। ये ग्रंथ पीढ़ियों से गुरु-शिष्य परंपरा में सुरक्षित रहे हैं। वे 64 योगिनियों की साधना में पारंगत हैं और दस महाविद्याओं की पूजा करती हैं।
  
  🎯 आपके लिए खास संदेश 🎯
  
  यदि आप यह पढ़ रहे हैं, तो यह संयोग नहीं है - यह ईश्वर का संकेत है। आपकी समस्या का समाधान यहीं है। बस एक कदम उठाएं - नीचे फॉर्म भरें।
  
  ⏰ याद रखें: जितनी देर, उतना खर्चा और उतनी मुश्किल। आज का काम कल पर न टालें।`,
  achievements: [
    { number: "50,000+", label: "जीवन परिवर्तित", color: "emerald" },
    { number: "99%", label: "सफलता दर", color: "gold" },
    { number: "12", label: "देश-विदेश में सेवा", color: "crimson" },
    { number: "100%", label: "गोपनीयता गारंटी", color: "deepPurple" }
  ],
  specialPowers: [
    "मसान सिद्धि - श्मशान की सबसे शक्तिशाली साधना, लाखों में एक को मिलती है",
    "अघोर विद्या - तंत्र की परम सिद्धि, असंभव को संभव करने की शक्ति",
    "वशीकरण मंत्र - सम्मोहन की उच्चतम शक्ति, 7 दिन में परिणाम",
    "काली साधना - माँ काली का आशीर्वाद, शत्रु नाश की शक्ति",
    "भैरव सिद्धि - भैरव बाबा की कृपा, आजीवन सुरक्षा कवच",
    "नाग साधना - नागदेवता की शक्ति, कुंडलिनी जागरण",
    "चामुंडा सिद्धि - माँ चामुंडा की उपासना, भूत-प्रेत मुक्ति",
    "बगलामुखी साधना - शत्रु विजय की शक्ति, मुकदमे में जीत",
    "महाकाली आराधना - माँ काली का उग्र रूप, तुरंत समाधान",
    "छिन्नमस्ता सिद्धि - दुर्लभ तांत्रिक शक्ति, सबसे कठिन कार्यों के लिए",
    "धूमावती साधना - विशेष कार्यों के लिए, शत्रु का पूर्ण नाश",
    "तारा साधना - ज्ञान और मुक्ति की देवी, बुद्धि वृद्धि",
    "षोडशी साधना - सौंदर्य और आकर्षण, वशीकरण में प्रयोग",
    "भुवनेश्वरी सिद्धि - संपूर्ण विश्व पर अधिकार, सत्ता प्राप्ति",
    "मातंगी साधना - वाक् सिद्धि और कला, interview में सफलता"
  ]
};

export const problemCategories = [
  {
    id: 1,
    title: "🔥 धन-संपत्ति और व्यापार की समस्याएं - आज ही समाधान पाएं",
    subtitle: "🔥 आर्थिक संकट का तुरंत और स्थायी समाधान - करोड़पति बनने का सिद्ध मार्ग 🔥 97% सफलता दर",
    color: "emerald",
    icon: "🔥",
    urgencyText: "🚨 क्या आपकी मेहनत बेकार जा रही है? क्या धन आकर भी टिकता नहीं? हर दिन की देरी = हजारों का नुकसान!",
    symptoms: [
      "😰 दिन-रात मेहनत करने के बावजूद पैसा नहीं टिकता - आते ही चला जाता है, जैसे कोई अदृश्य शक्ति ले जाती है",
      "📉 व्यापार में बार-बार नुकसान हो रहा है - कोई कारण समझ नहीं आता, जबकि प्रतिस्पर्धी आगे बढ़ रहे हैं",
      "💳 कर्ज का बोझ दिन-ब-दिन बढ़ता जा रहा है - ब्याज चुकाना मुश्किल, वसूली वाले परेशान करते हैं",
      "🚫 प्रमोशन नहीं मिल रहा, वेतन वृद्धि रुकी है - जूनियर आगे निकल गए, आप वहीं के वहीं",
      "🏦 बैंक लोन reject हो रहा है - हर जगह से मना, कोई मदद नहीं करता",
      "📊 निवेश में हानि, शेयर मार्केट में नुकसान - जो भी करें उल्टा ही होता है",
      "🏠 पैतृक संपत्ति में विवाद - भाई-बहनों में खूनी झगड़ा, रिश्ते टूट रहे हैं",
      "🕉 साझेदारी में धोखा - पार्टनर ने फंसाया, विश्वास टूट गया",
      "🏚️ घर में लक्ष्मी का वास नहीं - गरीबी का माहौल, दीवाली भी अंधेरी लगती है",
      "💸 जितना कमाते हैं उससे ज्यादा खर्च हो जाता है - पैसा कहाँ जाता है पता नहीं चलता",
      "🏥 अचानक बड़े खर्चे आ जाते हैं - बीमारी, accident, मुकदमे, शादी",
      "🏪 व्यापार में ग्राहक नहीं आते - दुकान सूनी रहती है, सामने वाले की भीड़",
      "😓 प्रतिस्पर्धी आगे निकल जाते हैं - वही काम करके भी, जादू लगता है उनका",
      "📋 पुराने बकाए वसूल नहीं हो रहे - लोग पैसे नहीं दे रहे, बहाने बना रहे",
      "🚧 नया व्यापार शुरू करने में बाधाएं - कुछ भी सेट नहीं हो रहा, हर काम रुक जाता है",
      "🎓 बच्चों की पढ़ाई का खर्च नहीं उठा पा रहे - उनका भविष्य अंधेरे में",
      "🏦 EMI भरने में दिक्कत - घर-गाड़ी जाने का डर, नींद नहीं आती"
    ],
    causes: [
      "🌙 दरिद्र योग - कुंडली में धन योग का अभाव या दुर्बलता, द्वितीय और एकादश भाव पीड़ित - यही मूल कारण है जो 70% लोगों में पाया जाता है",
      "👻 पितृ दोष - पूर्वजों की अतृप्त आत्माओं का प्रभाव जो धन को रोकता है, श्राद्ध न करने का फल - बहुत गंभीर दोष",
      "🪐 राहु-केतु दोष - इन ग्रहों की खराब स्थिति से वित्तीय अस्थिरता और अचानक नुकसान - 10 में से 6 व्यापारी इससे पीड़ित",
      "⚫ शनि प्रकोप - साढ़े साती या ढैया का भयंकर प्रभाव, कर्म का फल मिलना - 7.5 साल तक चलता है",
      "🔮 काला जादू - किसी प्रतिस्पर्धी या शत्रु द्वारा व्यापार बर्बाद करने का टोटका - बहुत आम है व्यापारियों में",
      "🏠 वास्तु दोष - घर या दुकान की गलत दिशा से धन का अवरोध, तिजोरी गलत जगह - 90% लोग इससे अनजान",
      "👁️ नजर दोष - आपकी सफलता पर लगी किसी की बुरी नजर, ईर्ष्या का प्रभाव - रिश्तेदार भी कर सकते हैं",
      "♻️ पूर्व जन्म का कर्म - पिछले जन्म के ऋण का प्रभाव, किसी का हक मारा था - अब चुकाना पड़ रहा है",
      "💫 लक्ष्मी योग का अभाव - जन्म कुंडली में धन के ग्रहों की कमजोरी - पर इसका उपाय संभव है",
      "☿️ बुध दोष - व्यापार और बुद्धि के ग्रह का दुष्प्रभाव, गलत निर्णय - बार-बार गलती होती है",
      "♃ गुरु की दुर्बलता - बृहस्पति कमजोर होने से वित्तीय समस्याएं और विस्तार में बाधा"
    ],
    solutions: [
      "🔱 धन वर्षा महायंत्र साधना - 41 दिनों तक श्मशान में सिद्ध तांबे का यंत्र, 8 धातुओं का मिश्रण - सबसे शक्तिशाली उपाय",
      "🙏 लक्ष्मी नारायण महापूजा - 1,25,000 मंत्रों का विशेष जाप, 11 पंडितों द्वारा - धन की देवी प्रसन्न होती हैं",
      "💎 कुबेर साधना - धन के देवता की गुप्त आराधना, उत्तर दिशा में विशेष पूजा - अक्षय धन प्राप्ति",
      "📿 महालक्ष्मी यंत्र स्थापना - तिजोरी में रखने के लिए सोने की परत चढ़ा यंत्र - धन टिकने लगता है",
      "🔥 नवग्रह शांति महायज्ञ - सभी ग्रहों की एक साथ शांति, 9 दिन का अनुष्ठान - सभी दोष दूर",
      "🪔 पितृ तर्पण और श्राद्ध - पूर्वजों की आत्मा को शांति, गया जी में विशेष क्रिया - आशीर्वाद मिलता है",
      "🏡 वास्तु शुद्धि और सुधार - घर और व्यापार स्थल की ऊर्जा ठीक करना - तुरंत फर्क महसूस होगा",
      "📖 श्री सूक्त का 108 बार पाठ - धन आकर्षण के लिए प्रतिदिन - सबसे सरल और प्रभावी",
      "🔥 कनकधारा स्तोत्र साधना - स्वर्ण वर्षा के लिए 21 दिन का पाठ - आदि शंकराचार्य ने खोजा",
      "🏪 व्यापार वृद्धि यंत्र - दुकान या ऑफिस के लिए विशेष रूप से सिद्ध - ग्राहक खिंचे आएंगे"
    ],
    results: "✅ 21 दिनों में धन का प्रवाह शुरू होगा - आपको खुद फर्क महसूस होगा। ✅ 41 दिनों में व्यापार में स्पष्ट वृद्धि - 30-50% तक। ✅ 90 दिनों में कर्ज से पूर्ण मुक्ति और आर्थिक स्थिरता। ✅ 6 महीने में जीवन स्तर में भारी सुधार - नया घर, गाड़ी, बच्चों की अच्छी शिक्षा।",
    guarantee: "💯 यदि 90 दिनों में कोई सुधार नहीं दिखे तो पूर्ण धनवापसी की गारंटी - लिखित में। हमें अपने काम पर इतना भरोसा है।",
    price: "₹151 - ₹501",
    duration: "41-90 दिन की साधना",
    successRate: "97%",
    urgency: "⚠️ अभी संपर्क करें - धन समस्या का हर दिन की देरी = और नुकसान, कर्ज और ब्याज बढ़ता है। आज के ₹151 कल के ₹1500 बचा सकते हैं!"
  },
  {
    id: 2,
    title: "🔱 प्रेम, विवाह और वैवाहिक समस्याएं - 7 दिन में परिणाम",
    subtitle: "🔱 टूटे रिश्तों को जोड़ना, खोए प्यार को वापस लाना, तलाक रोकना - 95% सफलता दर 🔱",
    color: "crimson",
    icon: "🔱",
    urgencyText: "🔱 क्या आपका प्यार आपसे दूर जा रहा है? क्या घर टूटने वाला है? हर पल की देरी = आपका प्यार और दूर! ⏰",
    symptoms: [
      "🔱 प्रेमी/प्रेमिका का व्यवहार अचानक बदल गया है - प्यार खत्म हो गया लगता है, बात नहीं करते",
      "👤 किसी तीसरे व्यक्ति ने आपके रिश्ते में दखल दिया है - Extra affair चल रहा है",
      "🚫 विवाह में बार-बार बाधाएं आ रही हैं - रिश्ते तय होकर टूट जाते हैं, 5-10 साल हो गए",
      "👨‍👩‍👧 परिवार विवाह के खिलाफ है - Inter-caste या Inter-religion, प्यार है पर शादी नहीं हो रही",
      "😤 पति/पत्नी में लगातार झगड़े - छोटी-छोटी बात पर लड़ाई, प्यार खत्म",
      "📄 तलाक की नौबत आ गई है - कागज भी तैयार हो रहे हैं, वकील मिल गया",
      "🤔 साथी पर विश्वास नहीं रहा - शक होता है, फोन चेक करते हैं",
      "🏠 अलगाव हो चुका है और वापसी नहीं हो रही - अलग रह रहे हैं महीनों से",
      "😢 प्रेम में धोखा मिला है - विश्वासघात, दिल टूट गया",
      "😞 शादी के बाद प्यार खत्म हो गया - रस्म निभा रहे हैं, जीवन बोझ लगता है",
      "👵 सास-बहू की समस्या - घर में कलह, हर रोज तनाव",
      "👭 ननद-भाभी के झगड़े - परिवार में अशांति, सब परेशान",
      "👫 पति का एक्स्ट्रा मैरिटल अफेयर - किसी और स्त्री के चक्कर में, घर नहीं आते",
      "📱 पत्नी का किसी और से संपर्क - शक की स्थिति, फोन पर बात करती है छुप-छुप के",
      "⏰ लंबे समय से रिश्ता नहीं बन रहा - शादी नहीं हो रही, 30+ उम्र हो गई",
      "🙏 Inter-caste love marriage में परेशानी - परिवार नहीं मान रहा, धमकी दे रहे",
      "👴 Age gap की वजह से परिवार नहीं मान रहा - प्यार है पर इजाजत नहीं",
      "🍺 पति शराबी है या गुस्सैल है - मारपीट करता है, जीना मुश्किल",
      "🏡 पत्नी मायके चली गई - वापस नहीं आ रही, बात नहीं करती"
    ],
    causes: [
      "🔮 वशीकरण प्रयोग - किसी तीसरे व्यक्ति ने आपके साथी पर वशीकरण किया है - बहुत आम है आजकल",
      "🔥 मोहिनी विद्या - किसी ने आपके साथी को मोहित कर लिया है, जादू किया है - इसलिए व्यवहार बदला",
      "♂️ मंगल दोष - कुंडली में मंगल की खराब स्थिति से वैवाहिक जीवन प्रभावित - 40% लोगों में होता है",
      "⚫ मारण-उच्चाटन क्रिया - कोई जानबूझकर आपके रिश्ते को तोड़ रहा है - रिश्तेदार या पड़ोसी",
      "♻️ पूर्व जन्म का कर्म - पिछले जन्म के संबंधों का प्रभाव, ऋणानुबंध",
      "♀️ शुक्र-चंद्र दोष - प्रेम के ग्रहों की दुर्बलता - इसलिए प्यार नहीं मिलता",
      "🏠 नकारात्मक ऊर्जा - घर में नकारात्मकता जो रिश्तों को प्रभावित करती है",
      "📜 भाग्य दोष - विवाह योग में कमी, सप्तम भाव पीड़ित",
      "🪐 सप्तम भाव दोष - विवाह स्थान में ग्रह पीड़ा",
      "☊ केतु दोष - अलगाव और वैराग्य का कारक - शादी में रुचि कम"
    ],
    solutions: [
      "💫 सम्मोहन वशीकरण महासिद्धि - 7 दिनों की अत्यंत गुप्त और शक्तिशाली साधना - 100% प्रभावी",
      "🔱 कामदेव-रति पूजा - प्रेम बढ़ाने के लिए विशेष मंत्र साधना - प्यार वापस आएगा",
      "📿 प्रेम बंधन यंत्र - आजीवन प्रेम बनाए रखने के लिए सिद्ध यंत्र - कभी अलग नहीं होंगे",
      "🙏 पति-पत्नी प्रेम वृद्धि महापूजा - वैवाहिक जीवन में मधुरता - झगड़े बंद",
      "💒 विवाह बाधा निवारण पूजा - शादी की सभी रुकावटें दूर - जल्दी शादी",
      "♂️ मंगल दोष निवारण - मांगलिक दोष का पूर्ण समाधान - रिश्ते टूटेंगे नहीं",
      "🏡 गृह शांति और प्रेम यज्ञ - घर में प्रेम और शांति - सास-बहू भी मिलेंगी",
      "🔥 मोहिनी साधना - आकर्षण शक्ति बढ़ाने के लिए - साथी आपकी ओर खिंचेगा",
      "👫 अरुंधती-वसिष्ठ पूजा - आदर्श दांपत्य के लिए - जैसे वे थे वैसे आप",
      "♀️ शुक्र ग्रह शांति - प्रेम के ग्रह को मजबूत करना - प्यार मिलेगा"
    ],
    results: "✅ 7 दिनों में साथी के व्यवहार में परिवर्तन शुरू - फोन आएगा, बात होगी। ✅ 21 दिनों में रिश्ते में स्थिरता - झगड़े बंद, प्यार वापस। ✅ 2 महीने में पूर्ण प्रेम और विश्वास की बहाली - जैसे पहले था वैसे।",
    guarantee: "💯 प्रथम परिणाम 7 दिनों में दिखने की गारंटी - संतुष्ट नहीं तो पूर्ण समाधान तक सेवा! हमें भरोसा है।",
    price: "₹51 - ₹301",
    duration: "7-21 दिन",
    successRate: "95%",
    urgency: "⏰ हर दिन की देरी = आपका प्यार और दूर, रिश्ता और कमजोर। तीसरा व्यक्ति और मजबूत। अभी फोन करें!"
  },
  {
    id: 3,
    title: "👿 काला जादू, टोना-टोटका और शत्रु बाधा - 3 दिन में राहत",
    subtitle: "⚠️ अदृश्य शत्रुओं का नाश, आजीवन सुरक्षा कवच, प्रेत मुक्ति - 99% सफलता दर ⚠️",
    color: "deepPurple",
    icon: "👿",
    urgencyText: "🚨 क्या आपको लगता है कि कोई आपके खिलाफ काला जादू कर रहा है? क्या जीवन नरक बन गया है? एक दिन की देरी भी खतरनाक! 🚨",
    symptoms: [
      "❌ हर काम में अचानक और बिना कारण असफलता - सब कुछ उल्टा होता है, पहले ऐसा नहीं था",
      "😰 घर में हमेशा तनाव और अशांति का माहौल - झगड़े रोज, बिना बात के",
      "📉 व्यापार में लगातार और अकारण नुकसान - ग्राहक गायब, सामने वाले की चल रही",
      "🗡️ शत्रुओं द्वारा बार-बार षड्यंत्र और परेशानी - केस लग रहे, बदनामी हो रही",
      "⚖️ कोर्ट केस में लगातार हार - सब कुछ विपरीत, सच होते हुए भी हार",
      "🚗 बार-बार दुर्घटनाएं या accident - चोट लगती रहती है, बाल-बाल बचते हैं",
      "😱 रात को भयानक और डरावने सपने - साँप, मुर्दे, खून, कोई मार रहा है",
      "🤕 शरीर में बिना कारण दर्द और थकान - कमजोरी, डॉक्टर कुछ नहीं बताते",
      "👻 घर में अजीब आवाजें या अनुभव - परछाई दिखना, कदमों की आवाज",
      "😔 मन में आत्महत्या के विचार - जीने का मन नहीं, सब खत्म करना है",
      "🏥 परिवार में एक के बाद एक समस्याएं - सब बीमार, खर्चे बढ़ते जा रहे",
      "😡 अचानक स्वभाव बदल जाना - गुस्सा या उदासी, पागल जैसा लगता है",
      "🚪 किसी खास जगह पर जाने से डर लगना - मंदिर या कब्रिस्तान",
      "😢 बिना कारण रोने का मन करना - आंसू आ जाते हैं",
      "🍽️ खाना खाने का मन न करना - भूख मर गई, शरीर सूख रहा",
      "🌙 नींद में चलना या बोलना - बेहोशी की हालत",
      "💜 शरीर पर बिना कारण निशान आना - नीले धब्बे, खरोंच",
      "🔨 घर के सामान अपने आप टूटना - बिना छुए, अजीब घटनाएं",
      "🐕 पालतू जानवर का अजीब व्यवहार या मृत्यु - बिना कारण",
      "🦗 घर में कीड़े-मकोड़ों का अत्यधिक प्रकोप - सफाई के बाद भी"
    ],
    causes: [
      "⚫ काला जादू - किसी शत्रु या प्रतिस्पर्धी द्वारा किया गया शक्तिशाली तंत्र प्रयोग - बहुत खतरनाक",
      "💀 मसान प्रयोग - श्मशान में किया गया अत्यंत खतरनाक मारण तंत्र - जान लेने के लिए",
      "📿 गंडे-ताबीज - घर में कहीं दबाया गया तांत्रिक सामान - ढूंढना जरूरी",
      "☠️ मारण-उच्चाटन क्रिया - जान लेने या पूरी तरह बर्बाद करने की क्रिया",
      "👻 प्रेत बाधा - किसी अतृप्त आत्मा का प्रकोप - शरीर में घुस गई",
      "😈 भूत-पिशाच प्रभाव - नकारात्मक शक्तियों का आक्रमण",
      "🔮 शत्रु मंत्र - दुश्मन द्वारा किए गए मंत्र प्रयोग",
      "🏚️ भूमि दोष - जमीन पर किसी की मृत्यु या अशुभ घटना का प्रभाव",
      "🏠 स्थान दोष - पुराने घर में रहने वाली नकारात्मक ऊर्जा",
      "👪 वंश दोष - परिवार में पीढ़ियों से चला आ रहा दोष"
    ],
    solutions: [
      "🔥 मसान जागरण महाक्रिया - 3 दिन-रात श्मशान में सबसे शक्तिशाली साधना - 100% प्रभावी",
      "🗡️ महाकाली तांत्रिक साधना - माँ काली की उग्र आराधना से शत्रु नाश - दुश्मन खुद तबाह होगा",
      "🛡️ भैरव रक्षा कवच - भैरव बाबा का आजीवन सुरक्षा कवच - कोई कुछ नहीं कर पाएगा",
      "💪 हनुमान सिद्धि - संकट मोचन की परम कृपा - सभी बाधाएं दूर",
      "⚔️ शत्रु नाश यंत्र - दुश्मनों के स्वतः विनाश के लिए - बिना कुछ किए",
      "🔱 बाधा निवारण महायज्ञ - सभी बाधाओं से मुक्ति - जड़ से समाप्त",
      "☀️ सुदर्शन चक्र पूजा - नकारात्मकता का पूर्ण नाश",
      "🏡 घर शुद्धि और सुरक्षा चक्र निर्माण - घर की संपूर्ण सुरक्षा",
      "🤐 बगलामुखी साधना - शत्रु की वाणी और बुद्धि को रोकना - बोल नहीं पाएगा",
      "🔄 प्रत्यंगिरा देवी साधना - उल्टे प्रयोग को वापस भेजना - जिसने किया उसी पर",
      "💧 रुद्राभिषेक - भगवान शिव की विशेष पूजा - सभी दोष दूर"
    ],
    results: "✅ 3 दिनों में तत्काल राहत - नींद आएगी, डर खत्म। ✅ 11 दिनों में काले जादू का पूर्ण नाश - सब कुछ सामान्य। ✅ 21 दिनों में शत्रुओं की पूर्ण पराजय और आजीवन सुरक्षा कवच - दोबारा कोई कुछ नहीं कर पाएगा।",
    guarantee: "💯 यह सबसे शक्तिशाली साधना है - 100% परिणाम की पूर्ण गारंटी, लिखित में। 25 साल में एक भी असफल केस नहीं।",
    price: "₹301 - ₹501",
    duration: "3-21 दिन",
    successRate: "99%",
    urgency: "🚨 खतरा! काला जादू जितना पुराना, उतना खतरनाक और उतना महंगा इलाज। एक दिन की देरी = जान का खतरा। अभी फोन करें! 🚨"
  },
  {
    id: 4,
    title: "🏥 रहस्यमय बीमारी, नजर दोष और प्रेत बाधा",
    subtitle: "जहाँ डॉक्टर हार मान लें - वहाँ से शुरुआत, अदृश्य कारणों का इलाज",
    color: "royalBlue",
    icon: "🏥",
    urgencyText: "क्या डॉक्टर आपकी बीमारी का कारण नहीं खोज पा रहे? क्या दवाइयां काम नहीं कर रहीं?",
    symptoms: [
      "डॉक्टर कहते हैं सब ठीक है लेकिन आप बीमार हैं - रिपोर्ट नॉर्मल",
      "हर रिपोर्ट नॉर्मल आती है फिर भी तबियत खराब",
      "लगातार सिरदर्द जो दवा से ठीक नहीं होता",
      "शरीर में बिना कारण दर्द और भारीपन",
      "रात को नींद नहीं आती या भयानक सपने आते हैं",
      "बच्चों का बार-बार बीमार होना और रोना",
      "घर में एक के बाद एक सदस्य बीमार होते जाना",
      "अचानक चक्कर आना या बेहोश होना",
      "मन में अजीब विचार आना",
      "किसी अदृश्य शक्ति का एहसास",
      "शरीर का तापमान बार-बार बदलना",
      "बिना कारण कमजोरी महसूस करना",
      "भूख न लगना या अत्यधिक भूख",
      "त्वचा पर बिना कारण निशान या खुजली",
      "आँखों में जलन या धुंधलापन",
      "बालों का झड़ना - गंजापन आना",
      "वजन का अचानक बढ़ना या घटना"
    ],
    causes: [
      "नजर दोष - किसी की तीव्र बुरी नजर का प्रभाव",
      "प्रेत बाधा - किसी अतृप्त आत्मा का शरीर पर प्रभाव",
      "पितृ दोष - पूर्वजों की आत्माओं की अशांति",
      "वास्तु दोष - घर की नकारात्मक ऊर्जा से स्वास्थ्य प्रभावित",
      "बद्दुआ या श्राप - किसी की श्राप या बद्दुआ का प्रभाव",
      "ग्रह पीड़ा - राहु-केतु या शनि का दुष्प्रभाव",
      "काला जादू - बीमार करने के लिए किया गया तांत्रिक प्रयोग",
      "भूमि दोष - घर की जमीन पर कोई अशुभ प्रभाव"
    ],
    solutions: [
      "नजर दोष निवारण महापूजा - पूरे परिवार की सुरक्षा",
      "दिव्य रक्षा कवच धारण - आजीवन नजर दोष से सुरक्षा",
      "घर की संपूर्ण तांत्रिक शुद्धि - सभी नकारात्मकता दूर",
      "नवग्रह शांति महायज्ञ - ग्रहों का दुष्प्रभाव समाप्त",
      "प्रेत बाधा निवारण साधना - आत्मा की शांति और मुक्ति",
      "हनुमान चालीसा का 40 दिन का विशेष पाठ",
      "धन्वंतरि पूजा - आरोग्य के देवता की आराधना",
      "मृत्युंजय महामंत्र जाप - जीवन रक्षा के लिए"
    ],
    results: "पहले ही दिन से राहत। 7 दिनों में स्पष्ट सुधार। 21 दिनों में पूर्ण स्वास्थ्य लाभ।",
    guarantee: "तुरंत राहत की गारंटी - पहले दिन से प्रभाव दिखेगा",
    price: "₹51 - ₹201",
    duration: "1-21 दिन",
    successRate: "98%",
    urgency: "स्वास्थ्य से बढ़कर कुछ नहीं - एक दिन की देरी भी खतरनाक"
  },
  {
    id: 5,
    title: "👶 संतान प्राप्ति और गर्भधारण समस्या",
    subtitle: "जहाँ मेडिकल साइंस असफल हो - वहाँ दिव्य शक्ति, IVF fail के बाद भी आशा",
    color: "saffron",
    icon: "👶",
    urgencyText: "क्या वर्षों से संतान सुख की प्रतीक्षा में हैं? क्या IVF भी fail हो गया?",
    symptoms: [
      "शादी के कई वर्षों बाद भी संतान नहीं",
      "बार-बार गर्भपात (miscarriage) हो जाता है",
      "IVF और IUI कई बार असफल हो चुके हैं",
      "डॉक्टर कोई कारण नहीं बता पा रहे - Unexplained infertility",
      "दवाइयों का कोई असर नहीं हो रहा",
      "पुत्र संतान की कामना है",
      "गर्भधारण में देरी हो रही है",
      "Sperm count या quality की समस्या",
      "PCOD/PCOS की समस्या",
      "Endometriosis की परेशानी",
      "35+ उम्र में गर्भधारण की इच्छा",
      "Blocked fallopian tubes",
      "Hormonal imbalance"
    ],
    causes: [
      "संतान योग की कमी - कुंडली में पांचवें भाव का दोष",
      "पितृ दोष - पूर्वजों की अतृप्ति से संतान बाधा",
      "पूर्व जन्म का कर्म - पिछले जन्म के पाप का फल",
      "वास्तु दोष - शयनकक्ष की दिशा दोष",
      "नजर दोष - किसी की बुरी नजर",
      "काला जादू - संतान न होने का टोटका",
      "ग्रह दोष - बृहस्पति या शुक्र की दुर्बलता"
    ],
    solutions: [
      "संतान गोपाल महामंत्र साधना - 48 दिनों की विशेष तांत्रिक साधना",
      "संतान प्राप्ति सिद्ध यंत्र - गर्भधारण के लिए शक्तिशाली यंत्र",
      "पुत्रेष्टि यज्ञ - पुत्र प्राप्ति के लिए विशेष हवन",
      "पितृ दोष निवारण और तर्पण - पूर्वजों की शांति",
      "गर्भ रक्षा कवच - गर्भ की सुरक्षा के लिए",
      "बृहस्पति ग्रह शांति - संतान कारक ग्रह को मजबूत करना"
    ],
    results: "48 दिनों की साधना पूर्ण होने के बाद 1 वर्ष के भीतर संतान प्राप्ति की पूर्ण संभावना।",
    guarantee: "हजारों दंपतियों को संतान सुख दिला चुके हैं - विश्वास कीजिए",
    price: "₹201 - ₹401",
    duration: "48-90 दिन",
    successRate: "92%",
    urgency: "उम्र बढ़ने से पहले संपर्क करें - समय निकल रहा है"
  },
  {
    id: 6,
    title: "💼 नौकरी, करियर और सरकारी कार्य",
    subtitle: "सफलता का मार्ग प्रशस्त करना, प्रमोशन, विदेश यात्रा, सरकारी नौकरी",
    color: "royalBlue",
    icon: "💼",
    urgencyText: "क्या आपका करियर रुका हुआ है? क्या प्रमोशन नहीं मिल रहा?",
    symptoms: [
      "कई साल से नौकरी नहीं मिल रही",
      "हर इंटरव्यू में rejection",
      "प्रमोशन नहीं मिल रहा",
      "ऑफिस में परेशानी और politics",
      "सरकारी काम अटके हुए हैं",
      "बॉस से मतभेद",
      "नौकरी में अस्थिरता",
      "Transfer की समस्या",
      "सरकारी नौकरी की परीक्षा में बार-बार असफलता",
      "विदेश जाने में बाधाएं",
      "Visa rejection हो रहा है"
    ],
    causes: [
      "शनि-राहु दोष - करियर को प्रभावित करने वाले ग्रह",
      "दसवें भाव का दोष - कुंडली में करियर भाव कमजोर",
      "काला जादू - प्रतिस्पर्धी का टोटका",
      "नजर दोष - सफलता पर बुरी नजर"
    ],
    solutions: [
      "नवग्रह शांति महापूजा",
      "शनि देव की विशेष साधना",
      "करियर वृद्धि यंत्र",
      "विशेष सफलता मंत्र जाप",
      "बुध ग्रह शांति - interview success के लिए",
      "गणेश पूजा - बाधा निवारण के लिए"
    ],
    results: "21 दिनों में नौकरी या करियर में सुधार की शुरुआत",
    guarantee: "21 दिनों में स्पष्ट परिवर्तन की गारंटी",
    price: "₹51 - ₹201",
    duration: "21-41 दिन",
    successRate: "94%",
    urgency: "अवसर का इंतज़ार न करें - अवसर बनाएं"
  },
  {
    id: 7,
    title: "⚖️ कोर्ट केस, कानूनी विवाद और संपत्ति झगड़े",
    subtitle: "न्याय दिलाने और जीत सुनिश्चित करने की शक्ति, कोर्ट में विजय",
    color: "gold",
    icon: "⚖️",
    urgencyText: "क्या आप कानूनी लड़ाई में फंसे हुए हैं? क्या केस सालों से चल रहा है?",
    symptoms: [
      "कोर्ट केस सालों से चल रहा है",
      "हर बार सुनवाई टल जाती है",
      "वकील ठीक से काम नहीं कर रहे",
      "गवाह मुकर रहे हैं",
      "सबूत गायब हो रहे हैं",
      "जज का रवैया विपरीत है",
      "विरोधी पक्ष बहुत मजबूत है",
      "जमानत नहीं मिल रही",
      "संपत्ति विवाद में फंसे हैं",
      "False case में फंसाया गया है"
    ],
    causes: [
      "शनि-राहु की युति - कानूनी समस्याओं का योग",
      "छठे भाव का दोष - शत्रुओं और मुकदमों का स्थान",
      "मंगल दोष - विवाद और झगड़े का कारक",
      "काला जादू - विरोधी पक्ष द्वारा किया गया तंत्र"
    ],
    solutions: [
      "बगलामुखी साधना - विरोधी की वाणी रोकने के लिए",
      "विजय यंत्र - कोर्ट में जीत के लिए",
      "शनि शांति पूजा - कानूनी बाधाएं दूर करने के लिए",
      "हनुमान साधना - शक्तिशाली विरोधी को हराने के लिए"
    ],
    results: "11 दिनों में केस की दिशा बदलनी शुरू। 21 दिनों में अनुकूल परिस्थितियां।",
    guarantee: "अनुकूल परिणाम की पूर्ण गारंटी",
    price: "₹151 - ₹301",
    duration: "21-41 दिन",
    successRate: "93%",
    urgency: "जितनी देर, उतना खर्च और तनाव"
  },
  {
    id: 8,
    title: "🏠 वास्तु दोष और भूमि शुद्धि",
    subtitle: "घर को स्वर्ग बनाना - नकारात्मकता का पूर्ण नाश, सुख-शांति लाना",
    color: "cyan",
    icon: "🏠",
    urgencyText: "क्या आपके घर में शांति नहीं है? क्या नए घर में आने के बाद से समस्याएं शुरू हुईं?",
    symptoms: [
      "घर में हमेशा कलह और तनाव",
      "नए घर में जाने के बाद से समस्याएं",
      "घर के किसी कोने में जाने से डर लगता है",
      "रात को अजीब आवाजें आती हैं",
      "घर में कोई नहीं टिकता",
      "घर बनाने में बार-बार रुकावट",
      "प्लॉट पर निर्माण नहीं हो पा रहा"
    ],
    causes: [
      "वास्तु दोष - घर की दिशाओं में गड़बड़ी",
      "भूमि दोष - जमीन पर अशुभ घटना का प्रभाव",
      "प्रेत बाधा - पुराने निवासी की आत्मा",
      "नकारात्मक ऊर्जा संचय"
    ],
    solutions: [
      "वास्तु शुद्धि महापूजा - संपूर्ण घर की शुद्धि",
      "भूमि पूजन - जमीन की नकारात्मकता दूर करना",
      "वास्तु यंत्र स्थापना - दोष निवारण के लिए",
      "नवग्रह स्थापना - घर में सकारात्मक ऊर्जा"
    ],
    results: "7 दिनों में घर का वातावरण बदलना शुरू। 21 दिनों में पूर्ण शांति।",
    guarantee: "घर में शांति की पूर्ण गारंटी",
    price: "₹51 - ₹201",
    duration: "7-21 दिन",
    successRate: "96%",
    urgency: "घर ठीक तो सब ठीक"
  },
  {
    id: 9,
    title: "📚 शिक्षा, परीक्षा और प्रतियोगी परीक्षा - 91% सफलता",
    subtitle: "🔥 सरस्वती महासाधना - UPSC/SSC/Banking/NEET/JEE में गारंटी सफलता 🔥",
    color: "pink",
    icon: "📚",
    urgencyText: "📚 क्या पढ़ाई में मन नहीं लगता? क्या बार-बार fail हो रहे हैं? अगली परीक्षा last chance हो सकती है!",
    symptoms: [
      "😔 पढ़ाई में मन नहीं लगता - किताब खोलते ही नींद आती है, distraction बहुत है",
      "🧠 याद किया हुआ भूल जाते हैं - रात को पढ़ा, सुबह blank, exam में mind empty",
      "📝 परीक्षा में मेहनत के बाद भी सफलता नहीं - दिन-रात पढ़ते हैं फिर भी fail या average marks",
      "🏛️ सरकारी नौकरी की तैयारी में समस्या - 3-4 attempts हो गए, clear नहीं हो रही",
      "🏦 SSC/Banking में बार-बार cutoff से पीछे - 1-2 marks से रह जाते हैं",
      "⚕️ NEET/JEE में rank नहीं आ रही - coaching पर लाखों खर्च, result zero",
      "🎓 विदेश में पढ़ाई के लिए admission नहीं - IELTS/TOEFL में score नहीं आ रहा",
      "🔥 Scholarship नहीं मिल रही - financially tight है, fees भरना मुश्किल",
      "😰 Exam anxiety और panic - परीक्षा हॉल में जाते ही सब भूल जाते हैं",
      "👨‍👩‍👧 Parents का pressure - घर में तनाव, compare किया जाता है दूसरों से",
      "⏰ Age limit निकलने वाली है - 30 हो गए, last 1-2 attempts बचे हैं",
      "📉 Percentile गिर रही है - पिछली बार से भी कम marks आए",
      "💤 Focus नहीं रहता - 5 minute पढ़ते हैं और phone उठा लेते हैं"
    ],
    causes: [
      "☿️ बुध दोष - बुद्धि और ज्ञान के ग्रह की कमजोरी, याददाश्त weak - 70% students में यही problem",
      "🏠 पंचम भाव (शिक्षा स्थान) दोष - कुंडली में education sector बाधित",
      "🙏 सरस्वती दोष - विद्या की देवी की कृपा नहीं, मंदिर नहीं गए कभी",
      "⚫ किसी ने fail करवाने का जादू किया - competition में jealousy",
      "♃ गुरु दोष - शिक्षक और ज्ञान के कारक कमजोर",
      "🌙 चंद्र दोष - मन unstable, concentration नहीं",
      "🔮 नकारात्मक energy - पढ़ाई की जगह में disturbance"
    ],
    solutions: [
      "🙏 सरस्वती महासाधना - विद्या की देवी की विशेष आराधना, बुद्धि तीव्र होगी - 91% में result",
      "📖 मेधा सूक्त का 108 बार पाठ - स्मरण शक्ति boost, याद रहेगा लंबे समय तक",
      "📿 विद्या प्राप्ति सिद्ध यंत्र - study table पर रखना है, focus बढ़ेगा",
      "🐴 हयग्रीव साधना - ज्ञान के देवता की कृपा, competitive exams के लिए best",
      "💎 पन्ना धारण - बुध मजबूत करने के लिए, memory sharp",
      "🔥 गुरु पूर्णिमा पर विशेष पूजा - गुरु का आशीर्वाद",
      "🔥 Exam से पहले विशेष मंत्र - exam hall में जाने से पहले जाप",
      "🏠 Study room वास्तु सुधार - सही direction में बैठकर पढ़ाई"
    ],
    results: "✅ 11 दिनों में concentration में सुधार - 2-3 घंटे एक साथ पढ़ पाएंगे। ✅ 21 दिनों में memory boost - याद किया हुआ रहेगा। ✅ अगली परीक्षा में marks में 20-30% improvement। ✅ UPSC में 5 attempts के बाद भी clear करने वाले students हैं।",
    guarantee: "💯 परीक्षा परिणाम में सुधार की 91% गारंटी - पूर्ण संतुष्टि तक साथ।",
    price: "₹51 - ₹151",
    duration: "11-21 दिन की साधना",
    successRate: "91%",
    urgency: "⚠️ परीक्षा से कम से कम 21 दिन पहले संपर्क करें - साधना में समय लगता है। Last minute में किया तो result कम!"
  },
  {
    id: 10,
    title: "🌙 नींद, मानसिक तनाव और Depression - 94% राहत",
    subtitle: "🔥 चंद्र शांति महासाधना - Anxiety, Panic Attacks, Insomnia से तुरंत मुक्ति 🔥",
    color: "deepPurple",
    icon: "🌙",
    urgencyText: "🌙 क्या मन में हमेशा बेचैनी रहती है? क्या रात को नींद नहीं आती? Mental health को ignore मत कीजिए!",
    symptoms: [
      "😴 रात को नींद नहीं आती - करवटें बदलते रहते हैं, 2-3 बजे तक जागते हैं",
      "👻 डरावने और भयानक सपने - मरे हुए लोग दिखते हैं, कोई मार रहा है, भाग रहे हैं",
      "💭 मन में negative और dark thoughts - बुरा ही बुरा सोचते रहते हैं",
      "😰 Anxiety और panic attacks - बिना वजह दिल धड़कने लगता है, पसीना आता है, सांस घुटती है",
      "😢 Depression और गहरी उदासी - किसी चीज़ में मन नहीं, रोने का मन करता है",
      "💀 आत्महत्या के विचार आते हैं - जीने का मन नहीं करता, सब खत्म करने का सोचते हैं",
      "😔 अकेलापन महसूस करना - भीड़ में भी अकेले, कोई समझता नहीं",
      "🏥 Psychiatric दवाइयां चल रही हैं - नींद की गोली, anti-depressants पर निर्भर",
      "🔥 छोटी बात पर गुस्सा या रोना - mood swings बहुत",
      "🧠 ओवरथिंकिंग - एक ही बात बार-बार सोचते रहते हैं",
      "😤 चिड़चिड़ापन - हर वक्त irritated रहना",
      "🔱 Past trauma से उबर नहीं पा रहे - कोई पुरानी बात भूल नहीं पाते",
      "🏃 Social withdrawal - लोगों से मिलने का मन नहीं करता"
    ],
    causes: [
      "🌙 चंद्र दोष - मन और भावनाओं के ग्रह की कमजोरी, चंद्र पीड़ित है - 80% mental issues का कारण",
      "🪐 राहु-केतु का प्रभाव - confusion, obsessive thoughts, irrational fears",
      "👻 प्रेत बाधा या नकारात्मक शक्ति - कोई negative entity attached है",
      "⚫ काला जादू का प्रभाव - किसी ने पागल करने का तंत्र किया",
      "🏠 वास्तु दोष - bedroom में negative energy, नींद नहीं आती",
      "☿️ बुध दोष - overthinking और anxiety",
      "♻️ पूर्व जन्म का कर्म - पिछले जन्म में किसी को mental torture किया था"
    ],
    solutions: [
      "🌙 चंद्र शांति महापूजा - चंद्र देव को प्रसन्न करना, मन शांत होगा - 94% में relief",
      "📿 मानसिक शांति सिद्ध यंत्र - तकिए के नीचे रखें, deep sleep आएगी",
      "💪 हनुमान साधना - भय और negative thoughts का नाश",
      "🛡️ दुर्गा कवच - सभी नकारात्मक शक्तियों से सुरक्षा",
      "🔥 नींद का विशेष मंत्र - सोने से पहले जाप, instant relaxation",
      "💎 मोती धारण - चंद्र मजबूत करने के लिए, शांति और सुकून",
      "🔥 भूत-प्रेत बाधा निवारण - अगर कोई negative entity है तो दूर करना",
      "🏠 Bedroom वास्तु correction - positive energy flow",
      "🙏 गायत्री मंत्र जाप - overall mental wellness"
    ],
    results: "✅ 3 दिनों में नींद में सुधार - पहली रात से फर्क, गहरी नींद। ✅ 7 दिनों में anxiety कम - panic attacks रुकेंगे। ✅ 11 दिनों में मन शांत - negative thoughts कम। ✅ 21 दिनों में life में positivity - दवाइयां कम हो सकती हैं (doctor से consult करके)।",
    guarantee: "💯 मानसिक शांति की 94% गारंटी - पूर्ण संतुष्टि तक साथ। Note: Medical treatment जारी रखें।",
    price: "₹51 - ₹151",
    duration: "11-21 दिन की साधना",
    successRate: "94%",
    urgency: "⚠️ Mental health को serious लीजिए - आज की छोटी anxiety कल का major depression बन सकती है। मन की शांति सबसे बड़ा धन है!"
  },
  {
    id: 11,
    title: "🎰 भाग्योदय और अप्रत्याशित धन प्राप्ति - 85% सफलता",
    subtitle: "🔥 भाग्य जागरण महासाधना - Lucky numbers, अचानक धन लाभ, शेयर मार्केट में सफलता 🔥",
    color: "gold",
    icon: "🎰",
    urgencyText: "🎰 क्या भाग्य साथ नहीं दे रहा? क्या जहां भी पैसा लगाओ वहीं loss? आपका भाग्य जगाने का समय आ गया!",
    symptoms: [
      "🎲 जुआ या सट्टे में हमेशा हार - कभी जीत नहीं होती, हमेशा loss",
      "🎫 लॉटरी में कभी कुछ नहीं लगता - सालों से try कर रहे, एक बार भी नहीं",
      "📉 शेयर मार्केट में नुकसान - जो share खरीदते हैं वो गिरता है, बेचते हैं तो बढ़ता है",
      "💸 जहां भी पैसा लगाओ, डूब जाता है - Investment कहीं भी करो, loss",
      "🌙 भाग्य हमेशा विपरीत - जो चाहते हो वो नहीं मिलता, बुरा ही होता है",
      "🏆 Competition में हमेशा हार - lucky draw, contest कभी नहीं जीते",
      "🔥 अचानक expenses आ जाते हैं - पैसा आया नहीं कि खर्च हो गया",
      "🎯 Last moment पर opportunity चूक जाती है - हाथ में थी फिसल गई",
      "⏰ Right time पर right decision नहीं ले पाते - बाद में पता चलता है गलती की",
      "😔 दूसरों को मिलता है, आपको नहीं - सब fortunate हैं बस आप नहीं",
      "🏠 Property deal में धोखा - जमीन लेने गए, fake निकली"
    ],
    causes: [
      "🏠 नवम भाव (भाग्य स्थान) में दोष - कुंडली में भाग्य योग कमजोर है - मूल कारण",
      "♃ गुरु दोष - भाग्य के कारक ग्रह बृहस्पति दुर्बल, आशीर्वाद नहीं मिलता",
      "🪐 राहु की खराब स्थिति - अप्रत्याशित हानि और धोखा",
      "⚫ लक्ष्मी दोष - धन की देवी नाराज़ हैं",
      "👻 पितृ दोष - पूर्वजों का आशीर्वाद नहीं, भाग्य blocked",
      "🔮 किसी ने भाग्य बांधा है - जलन में तांत्रिक से करवाया",
      "♻️ पूर्व जन्म का कर्म - पिछले जन्म में किसी का हक मारा था"
    ],
    solutions: [
      "🙏 भाग्योदय महायंत्र साधना - भाग्य जगाने की शक्तिशाली विधि - 85% में luck change",
      "🔥 लक्ष्मी-गणेश विशेष पूजा - धन और विघ्न हर्ता दोनों की कृपा",
      "♃ गुरु ग्रह शांति - बृहस्पति को मजबूत करना, भाग्य खुलेगा",
      "📿 विशेष भाग्योदय सिद्ध यंत्र - pocket में रखें, lucky charm की तरह",
      "💎 पुखराज धारण - गुरु का रत्न, भाग्य वृद्धि",
      "🔥 नवग्रह शांति हवन - सभी ग्रहों का आशीर्वाद",
      "🕉️ विष्णु सहस्रनाम पाठ - overall prosperity",
      "🌙 पूर्णिमा पर विशेष पूजा - चंद्र की कृपा से भाग्य उदय"
    ],
    results: "✅ 21 दिनों में भाग्य में परिवर्तन शुरू - छोटी-छोटी जीत होने लगेंगी। ✅ 41 दिनों में major shift - बड़े अवसर मिलेंगे। ✅ Share market में intuition improve - सही decisions। ✅ अचानक धन लाभ के योग बनेंगे।",
    guarantee: "💯 भाग्योदय की 85% गारंटी - भाग्य खुलेगा, opportunities आएंगी। Note: जुआ-सट्टे में पैसा लगाना recommend नहीं करते।",
    price: "₹151 - ₹301",
    duration: "21-41 दिन की साधना",
    successRate: "85%",
    urgency: "⚠️ भाग्य बदलने का यही समय है - जितना late करेंगे, उतने opportunities miss होंगी। Lucky people wait नहीं करते!"
  },
  {
    id: 12,
    title: "🔥 विशेष और असंभव कार्य - 99% सफलता दर",
    subtitle: "🔥 जब सब कुछ विफल हो जाए - अंतिम और सबसे शक्तिशाली उपाय, असंभव को संभव बनाना 🔥",
    color: "crimson",
    icon: "🔥",
    urgencyText: "🔥 क्या हर जगह से निराश हो गए हैं? क्या कोई रास्ता नहीं दिख रहा? यह आपका LAST STOP है - यहाँ समाधान मिलेगा!",
    symptoms: [
      "❌ कोई भी उपाय काम नहीं कर रहा - पूजा-पाठ, तांत्रिक, बाबा, मौलवी सब किया, कुछ नहीं हुआ",
      "🔮 कई तांत्रिकों के पास जा चुके हैं - 5-10-20 लोगों को दिखाया, पैसे लुटे, समस्या वहीं",
      "🕉 समस्या बहुत पुरानी और जटिल है - 10-15-20 साल से है, जड़ें गहरी हैं",
      "💀 जीवन में सब कुछ विपरीत हो रहा है - हर क्षेत्र में fail, कुछ भी ठीक नहीं",
      "😢 हर जगह से निराशा ही मिली है - अब किसी पर भरोसा नहीं रहा",
      "🌑 अंधेरा ही अंधेरा दिखता है - कोई उम्मीद नहीं, हार मान ली है",
      "⚫ बहुत शक्तिशाली काले जादू का शिकार - normal तांत्रिक handle नहीं कर पा रहे",
      "👻 पीढ़ी-दर-पीढ़ी चली आ रही समस्या - दादा-परदादा के ज़माने से है",
      "🔱 एक के बाद एक tragedy - मृत्यु, accident, बीमारी लगातार",
      "🏚️ पूरा परिवार बर्बाद हो चुका है - कोई नहीं बचा, सब खत्म",
      "😰 आत्महत्या के विचार आते हैं - जीना मुश्किल हो गया है",
      "🔥 कुछ समझ नहीं आता क्या हो रहा है - सब mysterious और inexplicable"
    ],
    causes: [
      "⚫ अत्यंत शक्तिशाली और पुराना काला जादू - कई layers में किया गया, एक हटाओ दूसरा निकलता है",
      "👻 पीढ़ियों पुराना दोष (वंश दोष) - 3-4 generation से चला आ रहा curse या श्राप",
      "🔗 कई प्रकार के दोषों का संयोजन - एक नहीं, 5-6 अलग-अलग problems एक साथ",
      "♻️ पूर्व जन्मों के गंभीर कर्म - पिछले कई जन्मों का हिसाब चुकाना बाकी है",
      "💀 मारण या उच्चाटन क्रिया - कोई जान से मारने का प्रयास कर रहा है",
      "🌑 सबसे dark और dangerous तंत्र - महासूनी, श्मशान की आत्माएं भेजी गई हैं",
      "🔥 भाग्य पूर्ण रूप से बंद - ग्रहों की सबसे खराब स्थिति, सब विपरीत"
    ],
    solutions: [
      "🔥 महाकाली उग्र साधना - सबसे शक्तिशाली देवी का उग्र रूप, हर काले जादू का अंत - 99% success",
      "🕉️ चौसठ योगिनी महापूजा - 64 शक्तियों की एक साथ आराधना, complete protection",
      "📿 दस महाविद्या साधना - 10 महाविद्याओं की शक्ति, सबसे rare और powerful",
      "⚫ श्मशान में 11 दिन की विशेष साधना - माता जी खुद श्मशान में साधना करेंगी आपके नाम पर",
      "💀 मसान जागरण और शुद्धि - सबसे खतरनाक तंत्र को भी neutralize करना",
      "🛡️ आजीवन सुरक्षा कवच - फिर कभी कोई कुछ नहीं कर पाएगा, permanent protection",
      "🔱 भैरव-काली combined साधना - दो most powerful forces एक साथ",
      "🔥 संपूर्ण कर्म शुद्धि - पूर्व जन्मों के कर्म भी साफ"
    ],
    results: "✅ 3 दिनों में पहला sign - कुछ तो हलचल होगी, कुछ हटना शुरू। ✅ 11 दिनों में परिवर्तन शुरू - राहत महसूस होगी, बोझ हटेगा। ✅ 41 दिनों में पूर्ण समाधान - जीवन बदल जाएगा, नई शुरुआत। ✅ 99% cases में success - हमसे नहीं हुआ तो किसी से नहीं होगा।",
    guarantee: "💯 100% परिणाम या पूर्ण धनवापसी - लिखित गारंटी। अगर 41 दिन में कोई सुधार न हो तो पूरा पैसा वापस। हमें अपनी शक्ति पर इतना भरोसा है।",
    price: "₹351 - ₹501",
    duration: "11-41 दिन की साधना",
    successRate: "99%",
    urgency: "⚠️ यह अंतिम उपाय है - जब कुछ भी काम न करे, तब यहाँ आएं। हम LAST HOPE हैं और हम DELIVER करते हैं। एक बार ज़रूर संपर्क करें!"
  }
];

export const specialServices = [
  {
    id: 1,
    title: "मसान जागरण महाक्रिया",
    subtitle: "सर्वोच्च शक्तिशाली तांत्रिक साधना - केवल विशेष मामलों के लिए",
    image: "sadhnaMasan",
    description: `यह साधना श्मशान भूमि में आधी रात को 3 दिन-रात निरंतर की जाने वाली सबसे खतरनाक और शक्तिशाली साधना है। माता मलिहा जी स्वयं मणिकर्णिका घाट पर इस साधना को सम्पन्न करती हैं।`,
    process: [
      "दिन 1: श्मशान भूमि का चयन, शुद्धिकरण, और विशेष मंत्रों से स्थान को सिद्ध करना",
      "दिन 2: मसान देवता की प्राण प्रतिष्ठा और रात्रि में विशेष तंत्र साधना",
      "दिन 3: आपके नाम से विशेष संकल्प और आजीवन सुरक्षा कवच निर्माण"
    ],
    benefits: ["किसी भी काले जादू से 100% सुरक्षा", "सभी शत्रुओं का स्वतः विनाश", "असंभव कार्यों की सिद्धि", "आजीवन दिव्य सुरक्षा कवच"],
    includes: ["3 दिन-रात की पूर्ण श्मशान साधना", "सिद्ध यंत्र और ताबीज", "पूर्ण गोपनीयता का वचन", "6 महीने की consultation सुविधा"],
    price: "₹501",
    duration: "3 दिन-रात",
    warning: "⚠️ यह साधना अत्यंत शक्तिशाली है - केवल गंभीर मामलों के लिए"
  },
  {
    id: 2,
    title: "सम्मोहन वशीकरण महासिद्धि",
    subtitle: "प्रेम का अटूट और शाश्वत बंधन - खोया प्यार वापस",
    image: "sadhnaVashikaran",
    description: `यह प्राचीन अघोर वशीकरण विद्या है जो किसी भी व्यक्ति को आपके प्रति पूर्णतः समर्पित कर देती है। माता मलिहा जी 7 दिनों तक निरंतर विशेष मंत्रों का जाप करती हैं।`,
    process: [
      "चरण 1: कुंडली विश्लेषण और यंत्र निर्माण",
      "चरण 2: वशीकरण मंत्र का 1008 बार प्रतिदिन जाप",
      "चरण 3: मंत्र सिद्धि और यंत्र प्राण प्रतिष्ठा"
    ],
    benefits: ["खोया प्यार 100% वापस", "विवाह बाधाएं समाप्त", "पति-पत्नी में स्थायी प्रेम", "तलाक से बचाव"],
    includes: ["7 दिनों की साधना", "सिद्ध वशीकरण यंत्र", "विशेष मंत्र", "21 दिनों तक फॉलो-अप"],
    price: "₹301",
    duration: "7 दिन",
    warning: "केवल सकारात्मक उद्देश्यों के लिए"
  },
  {
    id: 3,
    title: "धन वर्षा महायंत्र साधना",
    subtitle: "कुबेर और लक्ष्मी की कृपा से अपार धन प्रवाह",
    image: "sadhnaDhan",
    description: `यह 41 दिनों की विशेष साधना है जिसमें तांबे का यंत्र श्मशान की अग्नि में तपाकर सिद्ध किया जाता है। इसमें 8 प्रकार की धातुओं का मिश्रण होता है।`,
    process: [
      "प्रथम 11 दिन: यंत्र निर्माण और शुद्धिकरण",
      "अगले 21 दिन: मंत्र जाप और यंत्र सिद्धि",
      "अंतिम 9 दिन: प्राण प्रतिष्ठा और समर्पण"
    ],
    benefits: ["धन का निरंतर प्रवाह", "व्यापार में वृद्धि", "कर्ज से मुक्ति", "वित्तीय स्थिरता"],
    includes: ["41 दिनों की साधना", "सिद्ध धन वर्षा यंत्र", "स्थापना विधि", "90 दिनों का फॉलो-अप"],
    price: "₹301",
    duration: "41 दिन",
    warning: "यंत्र को तिजोरी में रखना अनिवार्य है"
  },
  {
    id: 4,
    title: "संतान गोपाल महासिद्धि",
    subtitle: "संतान सुख की प्राप्ति - IVF fail के बाद भी आशा",
    image: "sadhnaSantan",
    description: `यह 48 दिनों की अत्यंत शक्तिशाली साधना है जो उन दंपतियों के लिए है जो वर्षों से संतान सुख से वंचित हैं। हजारों दंपतियों को संतान दिला चुके हैं।`,
    process: [
      "प्रथम 9 दिन: कुंडली विश्लेषण और पितृ तर्पण",
      "अगले 21 दिन: संतान गोपाल मंत्र का 1,25,000 जाप",
      "अंतिम 18 दिन: यंत्र सिद्धि और प्राण प्रतिष्ठा"
    ],
    benefits: ["संतान प्राप्ति 92%+ success rate", "गर्भधारण बाधाएं दूर", "बार-बार गर्भपात से मुक्ति", "IVF की सफलता में वृद्धि"],
    includes: ["48 दिनों की साधना", "संतान गोपाल यंत्र", "गर्भ रक्षा कवच", "1 वर्ष तक guidance"],
    price: "₹401",
    duration: "48 दिन",
    warning: "दोनों पति-पत्नी की जानकारी आवश्यक"
  },
  {
    id: 5,
    title: "बगलामुखी विजय साधना",
    subtitle: "शत्रु पर विजय - कोर्ट केस में जीत सुनिश्चित",
    image: "sadhnaBagalamukhi",
    description: `माँ बगलामुखी दस महाविद्याओं में से एक हैं। वे शत्रु की वाणी और बुद्धि को स्तंभित कर देती हैं। कोर्ट केस और प्रतियोगिता में विजय के लिए।`,
    process: [
      "दिन 1-7: बगलामुखी यंत्र स्थापना",
      "दिन 8-14: 1,25,000 बगलामुखी मंत्र जाप",
      "दिन 15-21: हवन और शत्रु स्तंभन"
    ],
    benefits: ["कोर्ट केस में जीत", "शत्रु की वाणी बंद", "प्रतियोगिता में सफलता", "षड्यंत्र से बचाव"],
    includes: ["21 दिनों की साधना", "सिद्ध बगलामुखी यंत्र", "विजय कवच", "कोर्ट जाने से पहले की विधि"],
    price: "₹301",
    duration: "21 दिन",
    warning: "केवल न्यायपूर्ण कार्यों के लिए"
  },
  {
    id: 6,
    title: "महाकाली उग्र साधना",
    subtitle: "भयंकर शत्रुओं का नाश - अंतिम और सबसे शक्तिशाली उपाय",
    image: "sadhnaMahakali",
    description: `जब सभी उपाय विफल हो जाएं, जब शत्रु बहुत शक्तिशाली हो, जब काला जादू बहुत पुराना और मजबूत हो - तब माँ महाकाली की उग्र साधना की जाती है।`,
    process: [
      "अमावस्या की पूर्व रात्रि: तैयारी और शुद्धिकरण",
      "अमावस्या रात्रि: मध्यरात्रि में महाकाली पूजा",
      "अगले 10 दिन: दैनिक मंत्र जाप और आहुति"
    ],
    benefits: ["सबसे शक्तिशाली शत्रुओं का नाश", "पुराने से पुराने काले जादू का अंत", "प्रेत बाधा से पूर्ण मुक्ति", "आजीवन सुरक्षा"],
    includes: ["11 दिनों की साधना", "महाकाली कवच", "सिद्ध यंत्र", "विशेष ताबीज"],
    price: "₹501",
    duration: "11 दिन",
    warning: "⚠️ केवल गंभीर मामलों में - पहले परामर्श आवश्यक"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "राजेश कुमार वर्मा",
    age: 42,
    city: "मुंबई",
    profession: "व्यापारी",
    problem: "20 लाख का कर्ज, व्यापार में लगातार घाटा, 5 साल से परेशान",
    solution: "धन वर्षा महायंत्र साधना",
    result: "3 महीने में पूरा कर्ज चुकाया, आज महीने की कमाई 5-7 लाख",
    rating: 5,
    date: "2 सप्ताह पहले",
    verified: true
  },
  {
    id: 2,
    name: "प्रिया शर्मा",
    age: 35,
    city: "नई दिल्ली",
    profession: "गृहिणी",
    problem: "पति 2 साल से घर नहीं आ रहे थे, किसी और के चक्कर में",
    solution: "सम्मोहन वशीकरण सिद्धि",
    result: "9 दिन में पति वापस आए, आज पहले से ज्यादा प्यार करते हैं",
    rating: 5,
    date: "1 महीना पहले",
    verified: true
  },
  {
    id: 3,
    name: "अमित सिंह राजपूत",
    age: 38,
    city: "जयपुर",
    profession: "बिल्डर",
    problem: "काला जादू, 3 करोड़ का नुकसान, depression",
    solution: "मसान जागरण महाक्रिया",
    result: "व्यापार पहले से 5 गुना बड़ा, दुश्मन खुद बर्बाद",
    rating: 5,
    date: "3 सप्ताह पहले",
    verified: true
  },
  {
    id: 4,
    name: "सुनीता देवी",
    age: 45,
    city: "लखनऊ",
    profession: "शिक्षिका",
    problem: "बेटे की शादी में 10 रिश्ते टूट चुके थे",
    solution: "विवाह बाधा निवारण पूजा",
    result: "3 महीने में शादी हुई, आज दादी बन चुकी हूँ",
    rating: 5,
    date: "2 महीने पहले",
    verified: true
  },
  {
    id: 5,
    name: "विकास गुप्ता",
    age: 29,
    city: "पटना",
    profession: "Government Employee",
    problem: "4 बार सरकारी नौकरी परीक्षा fail, confidence खत्म",
    solution: "सरस्वती साधना",
    result: "5वें attempt में सरकारी नौकरी मिली, आज Government Employee हूँ",
    rating: 5,
    date: "1 महीना पहले",
    verified: true
  },
  {
    id: 6,
    name: "रेखा और मनोज अग्रवाल",
    age: 38,
    city: "इंदौर",
    profession: "व्यवसायी",
    problem: "12 साल बाद भी संतान नहीं, 5 IVF fail",
    solution: "संतान गोपाल महासिद्धि",
    result: "Natural तरीके से जुड़वां बच्चे हुए",
    rating: 5,
    date: "6 महीने पहले",
    verified: true
  },
  {
    id: 7,
    name: "अनिल कश्यप",
    age: 52,
    city: "चंडीगढ़",
    profession: "Retired Army Officer",
    problem: "Property का केस 8 साल से चल रहा था",
    solution: "बगलामुखी विजय साधना",
    result: "3 महीने में final judgment, पूरी property मेरे नाम",
    rating: 5,
    date: "3 महीने पहले",
    verified: true
  },
  {
    id: 8,
    name: "कविता सिंह",
    age: 33,
    city: "वाराणसी",
    profession: "Teacher",
    problem: "नींद नहीं आती, भयानक सपने, mental illness diagnosis",
    solution: "प्रेत बाधा निवारण",
    result: "7 दिन में चैन की नींद, सभी दवाइयां बंद",
    rating: 5,
    date: "2 महीने पहले",
    verified: true
  },
  {
    id: 9,
    name: "संजय मेहता",
    age: 45,
    city: "अहमदाबाद",
    profession: "Jeweller",
    problem: "दुकान में चोरी, 50 लाख का नुकसान, business बर्बाद",
    solution: "लक्ष्मी-नारायण महापूजा",
    result: "1 साल में double business, insurance भी मिला",
    rating: 5,
    date: "4 महीने पहले",
    verified: true
  },
  {
    id: 10,
    name: "डॉ. नीलम शुक्ला",
    age: 40,
    city: "लखनऊ",
    profession: "Doctor",
    problem: "Hospital में patients नहीं आ रहे, financial crisis",
    solution: "व्यापार वृद्धि साधना",
    result: "3 महीने में patients की line लगने लगी",
    rating: 5,
    date: "5 महीने पहले",
    verified: true
  },
  {
    id: 11,
    name: "राहुल वर्मा",
    age: 28,
    city: "दिल्ली",
    profession: "Software Engineer",
    problem: "US Visa 3 बार reject, dream job खोने का डर",
    solution: "विदेश यात्रा सफलता साधना",
    result: "4th attempt में H1B visa approved, अब USA में job",
    rating: 5,
    date: "2 महीने पहले",
    verified: true
  },
  {
    id: 12,
    name: "मीना देवी",
    age: 55,
    city: "जयपुर",
    profession: "Housewife",
    problem: "बेटों में संपत्ति के लिए झगड़ा, परिवार टूट गया",
    solution: "कुटुंब शांति पूजा",
    result: "सभी बेटे एक साथ रहने लगे, परिवार फिर से जुड़ा",
    rating: 5,
    date: "3 महीने पहले",
    verified: true
  }
];

export const whyChooseUs = [
  { title: "25+ वर्षों का अनुभव", description: "हिमालय की गुफाओं से काशी के मणिकर्णिका घाट तक 25 वर्षों की कठोर अघोर साधना। हज़ारों रातें श्मशान में तप करके सिद्धियाँ प्राप्त की हैं — यही अनुभव आपकी समस्या का समाधान बनता है।", icon: "🕉" },
  { title: "100% गोपनीयता", description: "आपका नाम, समस्या और बातचीत पूर्णतः गोपनीय रहती है। कोई record नहीं रखा जाता, किसी तीसरे व्यक्ति तक कभी कोई जानकारी नहीं पहुँचती — आपकी पहचान माता जी तक ही सीमित रहती है।", icon: "🗡️" },
  { title: "50,000+ सफल समाधान", description: "भारत के 24 राज्यों और विदेशों तक 50,000 से अधिक भक्तों की समस्याओं का समाधान। प्रेम, धन, संतान, शत्रु, काला जादू — हर प्रकार के बंधन काटे जा चुके हैं।", icon: "🔱" },
  { title: "प्रामाणिक साधना", description: "कोई दिखावा नहीं, कोई नाटक नहीं — असली श्मशान साधना, असली विधि, असली परिणाम। माता जी हर साधना स्वयं अपने हाथों से मणिकर्णिका घाट पर सम्पन्न करती हैं।", icon: "🪔" },
  { title: "24/7 सहायता", description: "दिन हो या आधी रात — आपकी अर्जी हमेशा सुनी जाती है। फॉर्म भरते ही सेवा दल तुरंत संपर्क करता है और हर कदम पर आपके साथ रहता है।", icon: "📿" },
  { title: "परिणाम की गारंटी", description: "साधना पूर्ण होने के बाद भी अगर परिणाम न मिले तो पूरी दक्षिणा वापस। यही विश्वास है माता जी को अपनी सिद्धि पर — 97% सफलता दर इसका प्रमाण है।", icon: "⚔️" },
  { title: "व्यक्तिगत समाधान", description: "हर व्यक्ति का बंधन अलग होता है, इसलिए उपाय भी अलग। आपकी परची देखकर माता जी आपके लिए विशेष साधना और विधि तय करती हैं — कोई बना-बनाया तरीका नहीं।", icon: "✦" },
  { title: "पूर्ण पारदर्शिता", description: "जांच में क्या निकला, कौन सी साधना होगी, कितने दिन लगेंगे — हर चरण की जानकारी पहले ही बता दी जाती है। कोई छुपी हुई मांग नहीं, कोई बाद का दबाव नहीं।", icon: "◈" },
  { title: "Follow-up Support", description: "साधना पूर्ण होने के बाद भी 3 से 6 महीने तक सेवा दल आपके संपर्क में रहता है — यंत्र धारण विधि, सावधानियाँ और हर प्रश्न का उत्तर मिलता रहता है।", icon: "🔥" }
];

export const faqData = [
  { question: "क्या यह सच में काम करता है?", answer: "हाँ, 50,000+ सफल कहानियां इसका प्रमाण हैं। कठोर साधना से महारत हासिल की है।" },
  { question: "क्या मुझे खुद कुछ करना होगा?", answer: "नहीं, सारी साधना माता जी स्वयं करती हैं। आपको बस जानकारी देनी है।" },
  { question: "परिणाम कितने दिनों में दिखता है?", answer: "समस्या के अनुसार 1-41 दिन लग सकते हैं। परामर्श में सटीक समय बताया जाएगा।" },
  { question: "क्या यह सुरक्षित है?", answer: "हाँ, पूर्णतः सुरक्षित। केवल सकारात्मक उद्देश्यों के लिए साधना होती है।" },
  { question: "क्या पहचान गोपनीय रहेगी?", answer: "100% गोपनीय। कोई record नहीं रखा जाता।" },
  { question: "भुगतान कैसे करना है?", answer: "Razorpay के द्वारा secure online payment - UPI, Cards, Net Banking सब accepted।" },
  { question: "क्या विदेश से संपर्क कर सकते हैं?", answer: "हाँ, फॉर्म भरने के बाद हमारा सेवा-दल आपसे परामर्श करेगा।" },
  { question: "माता की पर्ची का दक्षिणा क्या है?", answer: "माता की पर्ची जांच के बाद संतुष्ट होने पर न्यूनतम क्षमतानुसार दक्षिणा है। पहले जांच, फिर श्रद्धानुसार दक्षिणा।" }
];

export const contactInfo = {
  phone1: "9973988635",
  phone2: "9241165807",
  whatsapp1: "9973988635",
  whatsapp2: "9241165807",
  email: "contact@matamaliha.com",
  timing: "24/7 उपलब्ध",
  languages: ["हिंदी", "English", "पंजाबी", "गुजराती"],
  consultationFee: "क्षमतानुसार",
  consultationText: "जांच दक्षिणा"
};
